/**Import react section */
import React from 'react'
import PropTypes from 'prop-types'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
/**Import material section */
import Close from '@material-ui/icons/Close'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import { IconButton } from '@material-ui/core'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import RefreshIcon from '@material-ui/icons/Refresh'
/**Import helpers section */
import { convertUrlImg } from '../ImageHelpper'
/**Import styles section */
import { ImageStyles } from './ImageStyles'

const ImageVisualizer = (props) => {
	/**array props sections */
	const { images } = props
	/**Bool props sections */
	const { canBeDelete, isLoadingDeleteImages } = props
	/**function props sections */
	const { onDeleteEvidence } = props

	const classes = ImageStyles()
	return (
		<div style={{ marginTop: '1rem' }}>
			<PhotoProvider
				toolbarRender={({ onScale, scale, rotate, onRotate }) => {
					return (
						<>
							<RefreshIcon onClick={() => onRotate(rotate + 90)} />
							<AddCircleOutlineIcon onClick={() => onScale(scale + 1)} />
							<RemoveCircleOutlineIcon onClick={() => onScale(scale - 1)} />
						</>
					)
				}}
			>
				{canBeDelete ? (
					<div style={{ display: 'flex' }}>
						{images.map((image, index) => (
							<div className={classes.imageBlock} key={index}>
								<IconButton
									onClick={() => onDeleteEvidence(image)}
									disabled={isLoadingDeleteImages}
									size='small'
									className={classes.deleteButon}
								>
									<Close fontSize='small' />
								</IconButton>
								<img src={convertUrlImg(image)} alt='attachment' className={classes.image} />
							</div>
						))}
					</div>
				) : (
					images.map((image, index) => (
						<PhotoView key={index} src={convertUrlImg(image)}>
							<img src={convertUrlImg(image)} alt='attachment' className={classes.image} />
						</PhotoView>
					))
				)}
			</PhotoProvider>
		</div>
	)
}

ImageVisualizer.propTypes = {
	images: PropTypes.array.isRequired
}

export default ImageVisualizer
